
import * as React from 'react';
import { FieldProps, Text, FormValue, Checkbox, } from 'informed';
import { FormGroup } from 'reactstrap';
import { createFieldProps, validateText } from '../form.utils';
import { InputModel } from './input.model';
import { FormErrorField } from '../FormError';
import { LabelCustom as Label } from '../..';
import { PasswordField } from './PasswordField';

export interface FormFieldProps<M> {
  fieldId: string;
  field: M;
  error: boolean;
  touched: boolean; 
}

export const TextField = (props: FormFieldProps<InputModel> & {autocomplete: InputModel['autocomplete']}) => {
  const {
    fieldId, 
    field, 
    error, 
    touched, 
  } = props;
  
  // TODO Replace any
  const fieldProps: FieldProps<any, any> & React.InputHTMLAttributes<HTMLInputElement> = createFieldProps(field, error, touched, fieldId);

  return (
    <FormGroup key={fieldId} className={['position-relative', (fieldProps.type === 'checkbox' ? 'form-group--checkbox' : '')].join(' ')}>
      {fieldProps.type === 'checkbox' && (
        <div className="checkbox">
          <Checkbox 
            {...fieldProps} 
            validate={(value: FormValue, values: any) => {
              return validateText(value, field, values);
            }} 
          />
        </div>
      )}

      {field.label && (
        <Label for={fieldId} mandatory={field.required} >
          <span className="field-label">{field.label}</span>
          <span className="checkmark"><></></span>
        </Label>
      )}
      {error && field.errorMessage && (
        <FormErrorField errorMessage={field.errorMessage || error[field.name]} tooltip={fieldId} />
      )}
      {fieldProps.type !== 'checkbox' && fieldProps.type === 'password' && (
        <PasswordField
          fieldProps={fieldProps}
          field={field}
        />
      )}
      {fieldProps.type !== 'checkbox' && fieldProps.type !== 'password' ? (
        <Text
          {...fieldProps}
          validate={(value: FormValue, values: any) => {
            return validateText(value, field, values);
          }}
        />
      ) : null}
    </FormGroup>
  );
};